import classNames from "classnames";
import * as React from "react";

import styles from "./DataTable.module.css";

interface DataTableRootProps {
  children: React.ReactNode;
}

/**
 * Outermost shell of the `DataTable` compound API: a full-height flex column
 * that hosts a `DataTable.Table` and any sibling chrome (filters, banners).
 *
 * @example
 * ```tsx
 * <DataTable.Root>
 *   <DataTable.Table {...tableProps} />
 * </DataTable.Root>
 * ```
 */
export function DataTableRoot({ children }: DataTableRootProps) {
  return <div className={classNames(styles.container)}>{children}</div>;
}
